// extracted by mini-css-extract-plugin
export default {"downloadBtnsContainer":"styles_downloadBtnsContainer__MBPRN","btnContainer":"styles_btnContainer__tt9G2"};